import type { CaseRecord, CaseIntervention, TeacherInputRequest } from "@/mocks/caseManagement";
import type { JudicialRequirement } from "@/mocks/judicialRequirements";

export function mapDbCaseToFrontend(dbCase: any): CaseRecord {
  return {
    id: dbCase.id,
    tenantId: dbCase.tenant_id,
    studentId: dbCase.estudiante_id,
    studentName: dbCase.estudiante_nombre || "Estudiante",
    curso: dbCase.estudiante_curso || "Sin curso",
    folio: dbCase.folio || `FOL-${String(dbCase.id).substring(0, 8).toUpperCase()}`,
    titulo: dbCase.titulo,
    descripcion: dbCase.descripcion || "",
    categoria: dbCase.tipo || "convivencia",
    tipo: dbCase.subtipo || dbCase.tipo || "general",
    prioridad: dbCase.prioridad || "media",
    estado: dbCase.estado || "abierto",
    judicializado: !!dbCase.judicializado,
    responsableId: dbCase.responsable_id || "",
    responsableName: dbCase.responsable_nombre || "Sin asignar",
    responsableRol: "Equipo de Apoyo",
    fechaApertura: dbCase.created_at ? new Date(dbCase.created_at).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
    fechaLimite: dbCase.fecha_limite ? new Date(dbCase.fecha_limite).toISOString().slice(0, 10) : "",
    fechaCierre: dbCase.fecha_cierre ? new Date(dbCase.fecha_cierre).toISOString().slice(0, 10) : null,
    createdBy: dbCase.creado_por || "",
    equipoIds: []
  };
}

export function mapDbInterventionToFrontend(dbInt: any): CaseIntervention {
  return {
    id: dbInt.id,
    tenantId: dbInt.tenant_id || "",
    caseId: dbInt.caso_id,
    tipoIntervencion: dbInt.tipo || dbInt.tipo_intervencion || "otro",
    descripcion: dbInt.descripcion || "",
    acuerdos: dbInt.acuerdos || "",
    proximosPasos: dbInt.proximos_pasos || dbInt.proximosPasos || "",
    responsableId: dbInt.realizado_por || dbInt.responsable_id || "",
    responsableName: dbInt.realizado_por_nombre || dbInt.responsable_nombre || "Profesional",
    responsableRol: dbInt.realizado_por_cargo || dbInt.responsable_rol || "Profesional",
    confidencial: !!dbInt.confidencial,
    fecha: dbInt.fecha ? new Date(dbInt.fecha).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
    fechaFormatted: dbInt.fecha ? new Date(dbInt.fecha).toLocaleDateString("es-CL") : new Date().toLocaleDateString("es-CL"),
    documentosAdjuntos: dbInt.evidencias || dbInt.documentosAdjuntos || []
  };
}

export function mapDbJudicialToFrontend(dbJud: any): JudicialRequirement {
  const daysDiff = dbJud.fecha_vencimiento 
    ? Math.ceil((new Date(dbJud.fecha_vencimiento).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
    : 10;
  
  let semaforo: "verde" | "amarillo" | "rojo" = "verde";
  if (dbJud.estado === "vencido" || daysDiff < 0) semaforo = "rojo";
  else if (daysDiff <= 3) semaforo = "amarillo";

  return {
    id: dbJud.id,
    tenantId: dbJud.tenant_id,
    studentId: dbJud.estudiante_id,
    studentName: dbJud.estudiante_nombre || "Estudiante",
    caseId: dbJud.caso_id || null,
    tribunal: dbJud.tribunal || "",
    rit: dbJud.rit_ruc || "",
    ruc: dbJud.rit_ruc || "",
    numeroCausa: dbJud.rit_ruc || "",
    tipoRequerimiento: dbJud.tipo_requerimiento || "Informe Social",
    fechaRecepcion: dbJud.fecha_recepcion ? new Date(dbJud.fecha_recepcion).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
    fechaLimite: dbJud.fecha_vencimiento ? new Date(dbJud.fecha_vencimiento).toISOString().slice(0, 10) : "",
    estado: dbJud.estado || "recibido",
    prioridad: (dbJud.prioridad || (daysDiff <= 3 ? "critica" : "media")) as any,
    responsableId: dbJud.responsable_id || null,
    responsableName: dbJud.responsable_nombre || "Sin asignar",
    responsableRol: "Profesional",
    documentoOrigenNombre: dbJud.oficio_url ? dbJud.oficio_url.split("/").pop() || "oficio.pdf" : "oficio.pdf",
    comprobanteEnvioNombre: null,
    fechaEnvio: null,
    createdBy: dbJud.creado_por || "",
    createdByName: "Oficina de Partes",
    createdAt: dbJud.created_at || new Date().toISOString(),
    updatedAt: dbJud.created_at || new Date().toISOString(),
    semaforo,
    semaforoMotivo: daysDiff < 0 ? "Vencido" : `Faltan ${daysDiff} días`,
    observaciones: ""
  };
}

export function mapDbInsumoToFrontend(dbInsumo: any): TeacherInputRequest {
  return {
    id: dbInsumo.id,
    tenantId: dbInsumo.tenant_id || "",
    caseId: dbInsumo.caso_id,
    courtRequestId: null,
    docenteId: dbInsumo.docente_id,
    docenteName: dbInsumo.docente_nombre || "Docente",
    tipoInsumo: dbInsumo.tipo_insumo || "Insumo docente",
    descripcionSolicitud: dbInsumo.instrucciones || "",
    fechaLimite: dbInsumo.plazo_entrega ? new Date(dbInsumo.plazo_entrega).toISOString().slice(0, 10) : "",
    estado: dbInsumo.estado || "pendiente",
    respuesta: dbInsumo.respuesta || null,
    submittedAt: dbInsumo.fecha_respuesta ? new Date(dbInsumo.fecha_respuesta).toISOString() : null,
    studentName: dbInsumo.estudiante_nombre,
    studentCurso: dbInsumo.estudiante_curso,
    caseFolio: dbInsumo.caso_folio
  };
}
